import _ from 'lodash';
import { AdditionalExercise } from '../store/additionalExercises/types';
import { AdditionalStage } from '../store/additionalStages/types';
import { Exercise } from '../store/exercises/types';
import { Mission } from '../store/missions/types';

export const getExercisesRewards = (exercise: Exercise, currentMission: Mission, exercisesList: Exercise[]) => {
    let exercises = exercisesList.filter(() => currentMission?.stages.flatMap((x) => x.exercises));
    if (!exercises.find((x) => x.id === exercise.id)) exercises.push(exercise);
    else
        exercises = exercises.map((x) => {
            return x.id !== exercise.id ? x : exercise;
        });
    return _.uniq(
        exercises
            .map((x) => {
                return x.reward;
            })
            .filter((x) => x),
    );
};

export const getAdditionalExercisesRewards = (
    exercise: AdditionalExercise,
    currentStage: AdditionalStage,
    exercisesList: AdditionalExercise[],
) => {
    let exercises = exercisesList.filter(() => currentStage?.additionalExercises);
    if (!exercises.find((x) => x.id === exercise.id)) exercises.push(exercise);
    else
        exercises = exercises.map((x) => {
            return x.id !== exercise.id ? x : exercise;
        });
    return _.uniq(
        exercises
            .map((x) => {
                return x.reward;
            })
            .filter((x) => x) ?? [],
    );
};
